import { render } from "./Portfolio.vue?vue&type=template&id=869e687a&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=869e687a&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/ftminstallatietechniek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869e687a"]])

export default __exports__